<ws-modal-wrapper [headerLabel]="(params.isNew ? 'Add' : 'Edit') + ' Property Characteristic'"
                  (save)="save()"
                  [disableSave]="descriptorForm.invalid"
                  acceptLabel="Save"
                  (cancel)="cancel()"
                  [loading]="saving">
    <form [formGroup]="descriptorForm" class="d-flex flex-column">
        <table class="table table-borderless mb-0">
            <tbody>
                <tr>
                    <td><label for="name">Characteristic Name:</label></td>
                    <td>
                        <input class="form-control"
                               type="text"
                               formControlName="name"
                               data-qa="property-characteristic-name"
                               maxlength="25">
                    </td>
                </tr>
                <tr>
                    <td><label for="companyUsageId">Company Usage:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="companyUsageId"
                                data-qa="property-characteristic-company-usage"
                                style="display: inline-block; width: auto;">
                            @for (usage of usages; track usage) {
                                <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><label for="siteUsageID">Site Usage:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="siteUsageID"
                                data-qa="property-characteristic-site-usage"
                                style="display: inline-block; width: auto;">
                            @for (usage of usages; track usage) {
                                <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><label for="parcelUsageID">Parcel Usage:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="parcelUsageID"
                                data-qa="property-characteristic-parcel-usage"
                                style="display: inline-block; width: auto;">
                            @for (usage of usages; track usage) {
                                <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><label for="assessorUsageID">Assessor Usage:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="assessorUsageID"
                                data-qa="property-characteristic-assessor-usage"
                                style="display: inline-block; width: auto;">
                            @for (usage of usages; track usage) {
                                <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                            }
                        </select>
                    </td>
                </tr>
                @if (hasComplianceFeatures) {
                    <tr>
                        <td><label for="assetUsageID">Asset Usage:</label></td>
                        <td>
                            <select class="form-select form-select-sm"
                                    formControlName="assetUsageID"
                                    data-qa="property-characteristic-asset-usage"
                                    style="display: inline-block; width: auto;">
                                @for (usage of assetUsages; track usage) {
                                    <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                }
                            </select>
                        </td>
                    </tr>
                }
                <tr>
                    <td><label for="arccUsageID">ARCC Usage:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="arccUsageID"
                                data-qa="property-characteristic-arcc-usage"
                                style="display: inline-block; width: auto;">
                            @for (usage of usages; track usage) {
                                <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><label for="fieldTypeID">Type:</label></td>
                    <td>
                        <select class="form-select form-select-sm"
                                formControlName="fieldTypeID"
                                data-qa="property-characteristic-field-type"
                                style="display: inline-block; width: auto;">
                            @for (fieldType of fieldTypes; track fieldType) {
                                <option [ngValue]="fieldType.descriptorFieldTypeID">{{ fieldType.name }}</option>
                            }
                        </select>
                        <descriptor-validation [validationForm]="validationForm"
                                               [descriptorForm]="descriptorForm"
                                               [descriptorId]="descriptor.descriptorID"
                                               [fieldTypeId]="descriptorForm.get('fieldTypeID').value">
                        </descriptor-validation>
                    </td>
                </tr>
                <tr>
                    <td><label for="notes">Comments:</label></td>
                    <td>
                        <textarea class="form-control"
                                  formControlName="notes"
                                  data-qa="property-characteristic-notes"
                                  cols="20"
                                  maxlength="200"
                                  rows="2">
                        </textarea>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <div class="property-chars-enabled text-center">
                            <label>
                                <input type="checkbox"
                                       formControlName="enabled"
                                       data-qa="property-characteristic-enabled"> Enabled
                            </label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
</ws-modal-wrapper>
